export default __webpack_public_path__ + "static/media/img5.02839b2c.png";